<template>
<section>
    <b-steps class="documents-wizard" :has-navigation="false">
        <b-step-item v-for="(file, index) in documents.list" :key="index" :label="file.docType" :step="index+1" clickable>
            <div class="modal-card">
                <header class="document-card-title modal-card-head" :title="file.name">
                    <div class="doc-title-holder">
                        <app-doc-icon :document="file.name"></app-doc-icon>
                        <p class="doc-title">{{file.name}}</p>
                    </div>

                    <div class="document-card-actions">
                        <b-button type="is-danger" class="card-footer-item" @click="deleteDropFile(index)" icon-left="delete" style="margin-left:12px;">
                        </b-button>
                    </div>
                </header>

                <b-field class="document-card-type modal-card-body">
                    <b-autocomplete placeholder="Document type" open-on-focus v-model="file.docType" :data="filteredDocType(index)" icon="magnify" clearable @select="selectedFileType($event, index, true)" @input="selectedFileType($event, index, false)">
                        <template #empty>No results found</template>
                    </b-autocomplete>
                </b-field>

                <!-- <div class="document-card-type modal-card-body">

                </div> -->
            </div>
        </b-step-item>

        <template #navigation="{previous, next}">

            <ul class="required-docs">
                <footer class="modal-card-foot wizard-footer">
                    <b-button type="is-success" label="Submit" @click="finishedWizard()" />
                    <b-button outlined type="is-danger" icon-left="step-backward" :disabled="previous.disabled" @click.prevent="previous.action">
                        
                    </b-button>
                    <b-button outlined type="is-success" icon-right="step-forward" :disabled="next.disabled" @click.prevent="next.action">
                        
                    </b-button>
                    <!-- <b-button type="is-danger" label="Close" @click="closeModal()" /> -->
                </footer>
                <li v-for="(document, index) in course.documents" v-bind:key="index" :class="document.uploaded || uploadedDoc(document) ? 'uploaded req-doc' : 'req-doc'">{{ document.name }}</li>

            </ul>

            
        </template>
    </b-steps>
</section>
</template>

<script>
import {
    docType
} from '../../models/static'
import UtilService from '../../services/util';
import AppDocIcon from '../helpers/DocIcon.vue'

export default {
    name: "student-documents-wizard",
    components: {
        AppDocIcon,
    },
    props: ['studentDocuments', 'course'],
    data() {
        return {
            documents: {
                list: [],
                types: []
            },

            docType: [],
            customDocType: []
        };
    },
    computed: {
        isManagement() {
            return UtilService.isManagement()
        },

        allDocTypes() {
            return [...new Set([...this.docType, ...this.customDocType])]
        }
    },
    mounted() {
        this.docType = [...this.course.documents.map(doc => doc.name), ...docType];
        if(this.studentDocuments) {
            this.documents.list = [...this.studentDocuments]
        }
        
    },
    methods: {
        filteredDocType(index) {
            if (this.documents.types[index] === undefined || !this.documents.types[index]) {
                this.documents.types[index] = ''
            }

            return this.allDocTypes.filter((option) => {
                return option ? option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.documents.types[index].toLowerCase()) >= 0 : false
            })
        },
        selectedFileType(value, index, addToList) {
            this.documents.types[index] = value
            this.documents.types = [...this.documents.types];
            this.customDocType = []
            this.customDocType.push(value)

            if (!this.docType.includes(value) && addToList) {
                this.docType.push(value)
                this.customDocType = []
            }
        },
        uploadedDoc(doc) {
            return doc.name ? this.documents.types.includes(doc.name) : false
        },
        deleteDropFile(index) {
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to delete this document? This action cannot be undone',
                onConfirm: () => {
                    this.documents.list.splice(index, 1)
                    this.documents.types.splice(index, 1)
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Document succesfully deleted`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })

                    if (this.documents.list.length === 0) {
                        this.confirmCloseModal()
                    }
                }
            })
        },
        finishedWizard() {
            this.$emit('changed', this.documents)
        },
        closeModal() {
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to cancel your document upload? This action cannot be undone',
                onConfirm: () => {
                    this.confirmCloseModal()
                }
            })
        },
        confirmCloseModal() {
            this.$emit('changed', {
                list: [],
                types: []
            })
            this.$parent.close()
        }
    }
}
</script>

<style>
.documents-wizard.b-steps .steps .step-items {
    flex-wrap: nowrap;
    overflow-y: scroll;
}

.document-card-type.modal-card-body {
    min-height: 400px;
}

.documents-wizard.b-steps .steps+.step-content .step-item {
    margin: 0 auto;
}

.wizard-footer.modal-card-foot {
    background: transparent;
    border: none;
    display: flex;
    justify-content: center;
}

.required-docs {
    position: fixed;
    top: 230px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border-radius: 12px;
    padding: 12px 8px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;

    max-height: 250px;
    overflow-y: scroll;
}

ul.required-docs li {
    margin: 12px 0;
}
</style>
